<template>
  <b-dropdown class="package-dropdown" menu-class="shadow-sm overflow-visible" ref="dropdown" variant="link" :size="size" block no-caret :disabled="disabled">
    <template v-slot:button-content>
      <div class="custom-select text-left">
        <span v-if="!busy" :title="selected ? selected.name : ''" class="selected">
          <i v-if="selected" class="fa fa-fw fa-box-open"></i>
          {{ selected ? selected.name : placeholder }}
        </span>
        <span v-if="busy">
          <i class="fa fa-fw fa-circle-notch fa-spin"></i>
          {{ trans('please_wait') }}
        </span>
      </div>
    </template>
    <b-dropdown-text v-if="!!error" variant="danger">
      {{ error }}
    </b-dropdown-text>
    <b-dropdown-text v-if="busy && items == null">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </b-dropdown-text>
    <b-dropdown-item v-for="item in items" v-bind:key="item.id" :active="item.id == value" :disabled="disabled || busy" @click="onClickItem(item)">
      <i class="fa fa-fw fa-box-open"></i>
      <span>{{ item.name }}</span>
    </b-dropdown-item>
    <b-dropdown-divider></b-dropdown-divider>
    <b-dropdown-text>
      <b-row>
        <b-col class="text-center">
          <b-button variant="link" class="p-0" :disabled="disabled || busy || page == 1" @click="onPreviousPage">
            <i class="fa fa-fw fa-chevron-left"></i>
          </b-button>
        </b-col>
        <b-col v-if="nullable" class="text-center">
          <b-button variant="link" class="p-0 text-danger" :disabled="disabled || busy || !value" :title="trans('clear')" v-b-tooltip.hover @click="onClear">
            <i class="fa fa-fw fa-times"></i>
          </b-button>
        </b-col>
        <b-col class="text-center">
          <b-button variant="link" class="p-0" :disabled="disabled || busy || page == last_page" @click="onNextPage">
            <i class="fa fa-fw fa-chevron-right"></i>
          </b-button>
        </b-col>
      </b-row>
    </b-dropdown-text>
  </b-dropdown>
</template>

<style>
  .package-dropdown.b-dropdown>button {
    padding: 0;
  }
  .package-dropdown>ul.dropdown-menu {
    min-width: 300px;
  }
</style>

<script>
  export default {
    props: {
      organization: Object,
      value: {
        type: Number,
        default: null,
      },
      size: {
        type: String,
        default: 'md',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      nullable: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: trans('choose_a_package'),
      },
      initial_short_url: String,
      pickFirstIfNull: {
        type: Boolean,
        default: false,
      },
      onlyWithPlayers: {
        type: Boolean,
        default: false,
      },
      withLocationIds: Array,
      loadPackageGrids: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        trans: trans,
        numeral: numeral,
        busy: false,
        error: null,
        items: null,
        selected: null,
        staff: null,
        total: null,
        page: 1,
        last_page: 1,
        per_page: 10,
      }
    },
   	methods: {
      refresh() {
        this.fetch()
      },
      onClear() {
        this.selected = null
        this.$emit('input', null)
        this.$emit('package', null)
        this.$refs.dropdown.hide(true)
      },
      onPreviousPage(bvEvt) {
        if (this.page <= 1) return
        this.page -= 1
        this.fetch()
      },
      onNextPage(bvEvt) {
        if (this.page >= this.last_page) return
        this.page += 1
        this.fetch()
      },
      onClickItem(item) {
        this.selected = item
        this.$emit('input', item.id)
        this.$emit('package', item, {source: 'user'})
      },
   	  fetch(firstTime) {
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/package/list?per_page=${this.per_page}&page=${this.page}`
        if (this.value) url += `&selected=${this.value}`
        if (this.onlyWithPlayers) url += `&only_with_players=true`
        if (!!this.withLocationIds && this.withLocationIds.length > 0) {
          url += `&location_ids=${this.withLocationIds.join(',')}`
        }
        if (this.loadPackageGrids) url += `&load_package_grids=true`
        axios.get(url)
        .then(response => {
          this.busy = false
          this.total = response.data.total
          this.page = response.data.current_page
          this.last_page = response.data.last_page
          this.items = response.data.data
          if (response.data.selected) {
            if (this.value != response.data.selected.id) this.$emit('input', response.data.selected.id)
            this.selected = response.data.selected
          }
          else if (this.pickFirstIfNull && this.items.length > 0) {
            this.selected = this.items[0]
          }
          this.$emit('loaded')
          if (this.selected) this.$emit('package', this.selected, {source: 'fetch'})
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
   	  },
   	},
   	mounted() {
      window.packageDropdown = this
      this.fetch(true)
   	},
  }
</script>